module.exports = __webpack_public_path__ + "assets/img/select_products6.e45061bf.svg";